import { render } from "./OrderCreate.vue?vue&type=template&id=518ce39e&scoped=true"
import script from "./OrderCreate.vue?vue&type=script&lang=js"
export * from "./OrderCreate.vue?vue&type=script&lang=js"

import "./OrderCreate.vue?vue&type=style&index=0&id=518ce39e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518ce39e"]])

export default __exports__